import InstallMobileIcon from '@mui/icons-material/InstallMobile';
import MedicationIcon from '@mui/icons-material/Medication';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import SignLanguageIcon from '@mui/icons-material/SignLanguage';
import SpeedIcon from '@mui/icons-material/Speed';
import React from 'react';

import { SURVEILLANCE_EXAM_NAME } from 'FRONTEND/utils/constants';


export const MatchIconFromExam = ({ examIcon }: { examIcon?: string | null }) => {
  switch (examIcon) {
    case 'material/MonitorHeart':
      return <MonitorHeartIcon />;
    case 'material/SignLanguage':
      return <SignLanguageIcon />;
    case 'material/Medication':
      return <MedicationIcon />;
    case 'material/QueryStats':
      return <QueryStatsIcon />;
    case SURVEILLANCE_EXAM_NAME.MULTIPARAMETRIC_DATA:
      return <InstallMobileIcon />;
    case 'material/Speed':
      return <SpeedIcon />;
    default:
      return <MonitorHeartIcon />;
  }
};
